import Vue from 'vue';
import Vuetify from 'vuetify/lib';

// import colors from 'vuetify/lib/util/colors';

import IconEdit from '@/components/icons/IconEdit.vue'
import IconEditPencil from '@/components/icons/IconEditPencil.vue'
import IconDelete from '@/components/icons/IconDelete.vue'
import IconInformation from '@/components/icons/IconInformation.vue'
import IconLsMessage from '@/components/icons/IconLsMessage.vue'
import IconLsInput from '@/components/icons/IconLsInput.vue'
import IconLsKeyboard from '@/components/icons/IconLsKeyboard.vue'
import IconLsAction from '@/components/icons/IconLsAction.vue'
import IconLsSearchlist from '@/components/icons/IconLsSearchlist.vue'
import IconLsSlider from '@/components/icons/IconLsSlider.vue'
import IconLsConnectFrom from '@/components/icons/IconLsConnectFrom.vue'
import IconLsConnecTo from '@/components/icons/IconLsConnecTo.vue'
import IconSave from '@/components/icons/IconSave.vue'
import IconLogout from '@/components/icons/IconLogout.vue'
import IconMenuCog from '@/components/icons/IconMenuCog.vue'
import IconMenuDialog from '@/components/icons/IconMenuDialog.vue'
import IconMenuOp from '@/components/icons/IconMenuOp.vue'
import IconMenuOpSettings from '@/components/icons/IconMenuOpSettings.vue'
import IconMenuBroadcast from '@/components/icons/IconMenuBroadcast.vue'
import IconMenuFilemanager from '@/components/icons/IconMenuFilemanager.vue'
import IconUserInputTollbox from '@/components/icons/IconUserInputTollbox.vue'
import IconArrowRightLong from '@/components/icons/IconArrowRightLong.vue'
import IconArrowLeftLong from '@/components/icons/IconArrowLeftLong.vue'
import IconLogin from '@/components/icons/IconLogin.vue'
import IconPasswd from '@/components/icons/IconPasswd.vue'
import IconEye from '@/components/icons/IconEye.vue'
import IconEyeNo from '@/components/icons/IconEyeNo.vue'
import IconNewChat from '@/components/icons/IconNewChat.vue'
import IconArrowRightShort from '@/components/icons/IconArrowRightShort.vue'
import IconExportXls from '@/components/icons/IconExportXls.vue'
import IconCopyLink from "@/components/icons/IconCopyLink.vue";
import IconSort from "@/components/icons/IconSort.vue";
import IconTableEdit from "@/components/icons/IconTableEdit.vue";
import IconTelegram from "@/components/icons/IconTelegram.vue";
import IconHeadphonesPlus from "@/components/icons/IconHeadphonesPlus.vue";
import IconEyePlus from "@/components/icons/IconEyePlus.vue";
import IconAddChatUser from "@/components/icons/IconAddChatUser.vue"
import IconAiButton from '@/components/icons/IconAiButton.vue';
import IconDialogSummaryAlt from '@/components/icons/IconDialogSummaryAlt.vue';
import IconFileVideo from "@/components/icons/IconFileVideo.vue";
import IconFiles from "@/components/icons/IconFiles.vue";
import IconCopilot from "@/components/icons/IconCopilot.vue";
import iconFillPage from "@/components/icons/IconFillPage.vue";
import IconFbMeta from "@/components/icons/IconFbMeta.vue";
import IconTextEditor from "@/components/icons/IconTextEditor.vue";
import IconMagicPen from "@/components/icons/IconMagicPen.vue";
import IconBillingOperators from '@/components/icons/IconBillingOperators.vue'
import IconBillingBotsSubscribers from '@/components/icons/IconBillingBotsSubscribers.vue'
import IconBillingDynamicData from '@/components/icons/IconBillingDynamicData.vue'
import IconBillingStaticData from '@/components/icons/IconBillingStaticData.vue'
import IconGoogle from "@/components/icons/IconGoogle.vue";
import IconAiAgent from "@/components/icons/IconAiAgent.vue";
import IconEmailMessage from '@/components/icons/IconEmailMessage.vue'


Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: { customProperties: true },
        themes: {
            light: {
                primary: '#5567FF',
                primaryBrand: '#44546f',
                primaryLighten: '#5784eb',
                primaryLight: '#D6DCFA',
                primaryLighten1: '#8794FF',
                primaryBackground: '#f5f6fa',
                primaryButtonBg: '#C2D2F8',
                primaryBlue: '#5567FF',
                primaryBlueDark: '#537cdb',
                secondary: '#050038', // #FFCDD2
                gray: '#B0BEC8', // #FFCDD2
							 	grayDusty: '#979494',
							 	greyUnique: '#C9C9C9',
                gray1: '#AFAFAF',
                gray2: "#f8f8f8",
                gray4: '#F8F8F8',
                gray5: '#e4e4e4',
                blueHaze: '#d0d4e4',
                athensGray: '#F5F6F8',
                ghost: '#c3c6d4',
                accent: '#767396', // #3F51B5
                greyBlueLight: '#AEAEC5',
                greyPurple: '#6C6C8B',
                red: '#F51C5D',
                black: '#000',
                black2: '#292931',
                black3: '#484848',
                orangeLight1: "#fff0de",
								yellowChalk:	'#F4FFB2',
								opBorderGray: '#e4e4e4',
								opBgGray: '#f2f2f2',
								opBgGray2: '#f9f9f9',
								platinum: '#e6e6e6',

								ghost_white: '#F8FAFC',
								azureish_white: '#E2E8F0',
								slate_gray: '#64748B',
								anti_flash_white: '#F1F5F9',
								independence: '#475569',

            },
        },
    },
    customVariables: ['../scss/variables.scss'],
    icons: {
        values: {
						iconfont: 'mdi',
						dropdown: 'mdi-chevron-down',

            iconedit: { // name of our custom icon
                component: IconEdit, // our custom component
            },
						iconeditpencil: {
                component: IconEditPencil,
            },
            icondelete: {
                component: IconDelete,
            },
            iconinformation: {
                component: IconInformation,
            },
            iconlsmessage: {
                component: IconLsMessage,
            },
            iconlsinput: {
                component: IconLsInput,
            },
            iconlskeyboard: {
                component: IconLsKeyboard,
            },
            iconlsaction: {
                component: IconLsAction,
            },
            iconlssearchlist: {
                component: IconLsSearchlist,
            },
            iconlsslider: {
                component: IconLsSlider,
            },
            iconlsconnectfrom: {
                component: IconLsConnectFrom,
            },
            iconlsconnecto: {
                component: IconLsConnecTo,
            },
            iconsave: {
                component: IconSave,
            },
            iconlogout: {
                component: IconLogout,
            },
            iconmenucog: {
                component: IconMenuCog,
            },
            iconmenudialog: {
                component: IconMenuDialog,
            },
            iconmenuop: {
                component: IconMenuOp,
            },
            iconmenuopsettings: {
                component: IconMenuOpSettings,
            },
            iconmenubroadcast: {
                component: IconMenuBroadcast,
            },
            iconmenufilemanager: {
                component: IconMenuFilemanager,
            },
            iconUserInputTollbox: {
                component: IconUserInputTollbox,
            },
            iconArrowRightLong: {
                component: IconArrowRightLong,
            },
            iconArrowLeftLong: {
                component: IconArrowLeftLong,
            },
            iconAiButton: {
                component: IconAiButton,
            },
            iconlogin: {
                component: IconLogin,
            },
            iconpasswd: {
                component: IconPasswd,
            },
            iconeyeno: {
                component: IconEyeNo,
            },
            iconeye: {
                component: IconEye,
            },
            iconnewchat: {
                component: IconNewChat,
            },
            iconarrowrightshort: {
                component: IconArrowRightShort,
            },
            iconexportxls: {
                component: IconExportXls,
            },
            iconcopylink: {
                component: IconCopyLink,
            },
            iconsort: {
                component: IconSort,
            },
            icontableedit: {
                component: IconTableEdit,
            },
            icontelegram: {
                component: IconTelegram,
            },
						iconheadphonesplus: {
                component: IconHeadphonesPlus,
            },
						iconeyeplus: {
                component: IconEyePlus,
            },
            iconAddChatUser: {
                component: IconAddChatUser,
            },
						iconFileVideo: {
                component: IconFileVideo,
            },
						iconFiles: {
							component: IconFiles,
						},
						iconCopilot: {
                component: IconCopilot,
            },
						iconfillpage: {
                component: iconFillPage,
            },
						iconfbmeta: {
                component: IconFbMeta,
            },
						icontexteditor: {
                component: IconTextEditor,
            },
						iconmagicpen: {
                component: IconMagicPen,
            },
						iconbillingoperators: {
                component: IconBillingOperators,
            },
						iconbillingbotssubscribers: {
                component: IconBillingBotsSubscribers,
            },
            IconBillingDynamicData: {
                component: IconBillingDynamicData,
            },
            IconBillingStaticData: {
                component: IconBillingStaticData,
            },
						icongoogle: {
                component: IconGoogle,
            },
						iconaiagent: {
                component: IconAiAgent,
            },
            IconDialogSummaryAlt: {
              component: IconDialogSummaryAlt,
            },
            iconlsemailmessage: {
                component: IconEmailMessage,
            },
        },
    },
});
